document.addEventListener('DOMContentLoaded', () => {
  const mainImage = document.querySelector('.pz-product-main-image');
  const thumbs = document.querySelectorAll('.pz-product-thumb');

  if (!mainImage || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const imageUrl = thumb.dataset.pzImage;
      if (!imageUrl) return;

      mainImage.src = imageUrl;

      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
});